<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="waiverForm" class="ppl-p0">
    <div class="row" style="width: 100%; margin-left: 0">
      <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="startDate" class="ppl-form-label">
            Start Date<span [attr.aria-label]="'Required'">*</span>
          </nz-form-label>
          <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
            <ppl-date-picker formControlName="startDate" id="startDate" [showIcon]="true"
              placeholder="Start Date" dateFormat="mm/dd/yy" [readonlyInput]="true" [monthNavigator]="true"
              [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="startDate"
              [panelStyleClass]="'custom-calendar-panel'"
              ariaLabel="Start Date, required"
              [styleClass]="validationErrors['startDate'] ? 'error' : ''"></ppl-date-picker>
            @if (validationErrors['startDate']) {
              <span class="pl-1 error-message">{{ validationErrors['startDate'] }}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>

      <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="endDate" class="ppl-form-label">
            End Date
          </nz-form-label>
          <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
            <ppl-date-picker formControlName="endDate" id="endDate" [showIcon]="false"
              placeholder="End Date" dateFormat="mm/dd/yy" [readonlyInput]="true" [monthNavigator]="true"
              [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="endDate"
              [panelStyleClass]="'custom-calendar-panel'" [disabled]="true"
              ariaLabel="End Date, auto-calculated"></ppl-date-picker>
          </nz-form-control>
        </nz-row>
      </nz-form-item>

      <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="waiver" class="ppl-form-label">
            Waiver<span [attr.aria-label]="'Required'">*</span>
          </nz-form-label>
          <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
            <div [ngClass]="{'error': validationErrors['waiver'] }">
              <ppl-dropdown-select formControlName="waiver" id="waiver" [options]="waiverOptions"
                [optionLabel]="'label'" [optionValue]="'value'" placeholder="Waiver"
                arialabel="Waiver, required"></ppl-dropdown-select>
            </div>
            @if (validationErrors['waiver']) {
              <span class="pl-1 error-message">{{ validationErrors['waiver'] }}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>

      <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="comments" class="ppl-form-label">Comments</nz-form-label>
          <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
            <input nz-input formControlName="comments" id="comments" placeholder="Comments"
              aria-label="Comments" />
          </nz-form-control>
        </nz-row>
      </nz-form-item>
    </div>
  </form>
</div>
<div class="custom-row">
  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>
  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()"></ppl-button>
</div>
